export default __webpack_public_path__ + "static/media/b2183f46-5c6b-4573-867a-fe8178a8cb5b.827aeb5c.png";